// Logo padrão agora vem da tabela ImagensPadrao (totalmente em banco)
export const LOGO_EMPRESA_PADRAO = "/api/images/padrao/logo";

// Logos JKLWeb também em banco
export const LOGO_WHITE = "/api/images/padrao/logo-white";
export const LOGO_DARK = "/api/images/padrao/logo-dark";

export const APP_NAME = "JKLSystem";
